import request from 'lib/request';

export interface Response {
  code: number;
  msg: string;
  data: null;
}

export async function addProjecWhitelist(id: number, address: string) {
  const res = await request<Response>('/project/add_whitelist', {
    method: 'POST',
    data: {
      id,
      address,
    },
  });
  return res;
}
